export default __webpack_public_path__ + "static/media/wuye.5ea7d688.jpg";